import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vfmPlugin from 'vue-final-modal'
import Popper from 'vue3-popper';
import VueGtag from "vue-gtag";
import 'devextreme/dist/css/dx.light.css';


createApp(App)
.use(store)
.use(router)
.use(vfmPlugin)
.use(Popper)
.use(VueGtag, {
    config: { 
      id: "UA-212036163-1",
    },
  }, router)
.mount('#app');
